export default __webpack_public_path__ + "static/media/static_img_cr_flowchart.2cd05008.svg";